export const availableWithdrawTimes = [
  { label: 'Diário automático', value: '0' },
  { label: 'Manual', value: '1' }
];